@if (linkUrl()) {
  <a class="image-widget" [class]="size()" [href]="linkUrl()" target="_blank" rel="noopener noreferrer">
    <ng-container *ngTemplateOutlet="image"></ng-container>
  </a>
} @else {
  <div class="image-widget" [class]="size()">
    <ng-container *ngTemplateOutlet="image"></ng-container>
  </div>
}

<ng-template #image>
  @if (imageUrl()) {
    <div class="image-widget__image-container" [class]="size()">
      <img [src]="imageUrl()" [alt]="description() || title()" class="image-widget__image" />
    </div>
  }

  @if (title() || description()) {
    <div class="image-widget__content">
      @if (title()) {
        <h6 class="image-widget__title">{{ title() }}</h6>
      }
      @if (description()) {
        <p class="image-widget__description">{{ description() }}</p>
      }
    </div>
  }
</ng-template>
